import { format, parseISO } from 'date-fns';
import {
    numeralFormatter,
    numeralFormatterCurrency,
} from 'ns_libs/formatter';
import { PRO_FORMA_TABS } from 'views/ProFormaTable/constants';

export const formatProFormaValue = (
    valueToFormat: any,
    showCents: boolean = false,
    numberType?: 'currency' | 'percentage',
) => {
    let displayValue = valueToFormat?.toString().trim() || '';
    if (valueToFormat === null || valueToFormat === undefined || displayValue === '') {
        return '—';
    }
    if (numberType === 'percentage') {
        const percentageValue = Number(Number(valueToFormat) * 100).toFixed(10); // to ensure precision
        const numericValue = Number(percentageValue);
        displayValue = `${numeralFormatter(String(Math.abs(numericValue)), '0.00')}%`;
        if (numericValue < 0) {
            displayValue = `(${displayValue})`;
        }
    } else if (numberType === 'currency') {
        const numericValue = Number(valueToFormat);
        const showCentsFormat = showCents ? '$0,0.00' : '$0,0';
        displayValue = numeralFormatterCurrency(Math.abs(numericValue), showCentsFormat);
        if (numericValue < 0) {
            displayValue = `(${displayValue})`;
        }
    } else {
        const numericValue = Number(valueToFormat);
        const showCentsFormat = showCents ? '0,0.00' : '0,0';
        displayValue = numeralFormatterCurrency(Math.abs(numericValue), showCentsFormat);
        if (numericValue < 0) {
            displayValue = `(${displayValue})`;
        }
    }
    return displayValue;
};

export const formatMilestoneDate = (dateStr: string): string => {
    try {
        const parsed = parseISO(dateStr);
        return format(parsed, 'MMM yyyy');
    } catch {
        return '';
    }
};

export const getHeapClassName = (navName: string) => {
    const heapClassNames = {
        [PRO_FORMA_TABS.GENERAL_INFORMATION.name]: 'heap-deal-signup-step-3-general-info',
        [PRO_FORMA_TABS.DEVELOPMENT.name]: 'heap-deal-signup-step-3-development',
        [PRO_FORMA_TABS.OPERATIONS.name]: 'heap-deal-signup-step-3-operations',
        [PRO_FORMA_TABS.DISPOSITION.name]: 'heap-deal-signup-step-3-disposition',
    };
    return heapClassNames[navName] || '';
};
